var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"alert alert-warning mb-3 mb-md-4",attrs:{"role":"alert"}},[_c('strong',[_vm._v(_vm._s(_vm.$t('payroll.slpTemporarilyUnavailable')))])])])}
var staticRenderFns = []

export { render, staticRenderFns }